import $ from 'jquery';
import * as Utils from 'lib/utils';

const W = window;
const $W = $(W);
const $D = $(document);
const $B = $('body');
const $H = $('head');
const timers = {};

W.buildShippingLink = evt => {
  if (W.AUTH?.authenticated) {
    const id = $B.find('.item-details').data('id');
    const { user } = W.AUTH;
    const url = new URL('https://madcheetah.com/quoting/item');

    url.searchParams.append('item', id);
    url.searchParams.append('buyer', user.id);
    url.searchParams.append('name', `${user.first_name} ${user.last_name}`.trim());
    url.searchParams.append('email', user.email.email);
    url.searchParams.append('addr1', user.address1);
    url.searchParams.append('addr2', user.address2);
    url.searchParams.append('zip', user.zip_code);

    W.open(url, '_blank');
  } else {
    $.alert('Please login before attempting to get a shipping quote', 'Shipping Quote');
  }
};

const playSound = sound => {
  if (!W.AUTH.authenticated) return;
  //if (!W.AUTH.user.preferences.browser.sounds || $.storage.get('sounds') === 'muted') return;

  let $audio = $B.find(`#${sound}`);

  if (!$audio.length)
    $audio = $('<audio></audio>')
      .attr('id', sound)
      .attr('src', Utils.assetUri(`sfx/${sound}.mp3`))
      .appendTo($B);

  $audio[0].play();
  console.log('playing sound');
};

const onBackdrop = evt => {
  const backdrop = $(evt.relatedTarget || evt.target).data('backdrop');

  if (backdrop === true) $B.toggleClass('backdrop', evt.type === 'show');
};

/* prettier-ignore */
$W
  .on('websocket:closed', () => {
    $('.item-countdown').removeClass('text-warning invisible').addClass('text-strong text-danger').find('span').text('RECONNECTING');
  })

  .on('resize', () => {
    const height = $('.pane-header').outerHeight(true);
    $('.app-sidebar.left').css('max-height', `calc(100vh - ${height}px)`);
    $('.app-sidebar.right').css({ 'max-height': `calc(100vh - ${height}px)`, 'overflow-x': 'hidden' });

    if (!$('.featured-items-auction').length) return;

    $('.app-content').css('overflow', 'hidden');
    const width = $('.app-content').width();
    $('.featured-items-auction').css('max-width', width + 'px');
    $('.app-content').css('overflow', 'initial');
  });

/* prettier-ignore */
$D
  .on('show.bs.popover', onBackdrop)
  .on('show.bs.dropdown', onBackdrop)
  .on('hide.bs.popover', onBackdrop)
  .on('hide.bs.dropdown', onBackdrop)

  .on('freeze', () => {
    console.log('onfreeze');
  })

  .on('resume', () => {
    console.log('onresume');
  })

  .on('messages', (evt, channel, data = {}) => {
    const now = window.now;
    let [type, id] = channel.split(':');

    if (type === 'time') {
      $('.item-countdown').each((idx, obj) => {
        const $obj = $(obj).removeClass('text-strong text-warning text-danger invisible');
        const dt = Math.max(0, Math.floor($obj.data('end') - data));

        if (isNaN(dt)) $obj.find('span').text('');
        else if (dt === 0) $obj.addClass('text-strong text-danger').find('span').text('UPDATING');
        else {
          const v = [];
          let s = dt;
          let d = 0;
          let h = 0;
          let m = 0;

          if (s > 0) {
            d = Math.floor(s / 86400);
            s -= d * 86400;
            if (d >= 1) v.push(`${d} day${d === 1 ? '' : 's'}`);

            h = Math.floor(s / 3600);
            s -= h * 3600;
            if (h >= 1) v.push(`${h} hour${h === 1 ? '' : 's'}`);

            m = Math.floor(s / 60);
            s -= m * 60;
            if (m >= 1 && d < 1) v.push(`${m} minute${m === 1 ? '' : 's'}`);
          }

          if (h < 1 && d < 1) v.push(`${s} second${s === 1 ? '' : 's'}`);

          if (dt < 3600) $obj.addClass('text-strong');
          if (dt < 60) $obj.addClass(dt <= 10 ? ' text-danger' : ' text-warning');

          $obj.find('span').text(v.join(' '));
        }
      });

      return;
    }

    if (type === 'notify') {
      data = data.data;
      id = data.id;
      type = data.type;
    }

    if (!now || !id || !['auction', 'lot', 'product', 'listing'].includes(type)) return;

    console.groupCollapsed(`🕸 WS:MESSAGE`);
    console.log('TYPE', type);
    console.log('ID', id);
    console.log('DATA', data);
    console.groupEnd();

    $(`.${type}[data-id="${id}"]`).each((idx, obj) => {
      const $obj = $(obj);
      const item = $obj.data('item');
      const template = $obj.is('.item-tile') ? 'tile' : $obj.is('.item-simple') ? 'simple' : $obj.is('.item-details') ? 'details' : false;
      const timer_id = `${type}:${id}:${template}`;

      if (!item || !template) return;

      clearTimeout(timers[timer_id]);
      Object.assign(item, data);

      timers[timer_id] = setTimeout(() => {
        $obj.renderItem(template, item, { now, website: { id: W.AUTH.website.id } });
        timers[timer_id] = null;
      }, 150);
    });

    if (type === 'auction') {
      $(`[data-auction="${id}"]`).each((idx, obj) => {
        const $obj = $(obj);
        const item = $obj.data('item');
        const type = $obj.is('.lot') ? 'lot' : $obj.is('.product') ? 'product' : $obj.is('.listing') ? 'listing' : false;
        const template = $obj.is('.item-tile') ? 'tile' : $obj.is('.item-simple') ? 'simple' : $obj.is('.item-details') ? 'details' : false;
        const timer_id = `${type}:${item?.id}:${template}`;

        if (!item || !type || !template) return;

        clearTimeout(timers[timer_id]);

        delete data.type;
        Object.assign(item.auction, data);

        timers[timer_id] = setTimeout(() => {
          $obj.renderItem(template, item, { now, website: { id: W.AUTH.website.id } });
          timers[timer_id] = null;
        }, 150);
      });
    }
  })

  .on('shown.bs.collapse hidden.bs.collapse', evt => {
    const id = $(evt.target).data('id');

    if (id) $.storage.set(`${id}`, evt.type);
  })

  .on('click', '.app-content', evt => {
    if ($B.is('.menu')) $B.removeClass('menu');
  })

  .on('click', '.btn-freeze', async function() {
    const $btn = $(this);
    const $tile = $btn.closest('.item-tile, .item-details');
    const { id, type } = $tile.data('item');

    if (!(id > 0 && type === 'lot')) return;

    const result = await $.confirm('Are you sure you would like to freeze your bid on this lot? This will change your maximum bid amount to the current bid amount.', 'Freeze Bid');

    if (result) {
      await $.GraphQL.runQuery(
        `
          mutation freezeBid($lot_id: Int!) {
            freezeBid(lot_id: $lot_id) 
          }
        `,
        {
          variables: { lot_id: id },
          operationName: 'freezeBid',
        },
      );
    }
  })

  .on('click', '.btn-bid', async evt => {
    const $btn = $(evt.target).closest('.btn');
    const $tile = $btn.closest('.item-tile, .item-details');
    const amount = $btn.closest('.input-group').find('[name="amount"]').val();
    const { id, type } = $tile.data('item');

    if (!(id > 0 && type === 'lot')) return;

    if (!W.AUTH.authenticated) {
      const result = await $.modal('/login?reason=bid', { id: 'login' });
      if (result !== true) return;
    }

    if (W.AUTH.user.admin.is_bidder_agent !== true && W.SETTINGS.website.need_cc_to_bid && (W.AUTH.website.merchant && W.AUTH.website.merchant.id) && W.SETTINGS.user.need_cc_to_bid && !W.SETTINGS.user.has_valid_cc) {
      const result = await $.modal('/user/credit-cards/add?reason=bid', { id: 'credit_card', size: 'lg' });
      if (result !== true) return;
    }

    const result = await $.modal(`/lot/${id}/bid`, { id: 'bid', size: 'lg', params: { amount } });

    if (result) {
      setTimeout(() => {
        $(`.${type}[data-id="${id}"]`).each((idx, obj) => {
          const $obj = $(obj);
          const item = $obj.data('item');

          item.is_watched = true;
          $obj.addClass('watched');
        });
      }, 150);
    }
  })

  .on('click', '.btn-bid-history', async evt => {
    const $btn = $(evt.target).closest('.btn');
    const $tile = $btn.closest('.item-tile, .item-details');
    const data = $tile.data();

    await $.modal(`/lot/${data.id}/history`, { id: 'history', size: 'lg' });
  })

  .on('click', '.btn-buy', async evt => {
    const $btn = $(evt.target).closest('.btn');
    const $tile = $btn.closest('.item-tile, .item-details');
    const { id, type } = $tile.data('item');

    if (!(id > 0 && type === 'product')) return;

    if (!W.AUTH.authenticated) {
      const result = await $.modal('/login?reason=buy', { id: 'login' });
      if (result !== true) return;
    }

    await $.modal(`/product/${id}/buy`, { id: 'buy', size: 'xl' });
  })

  .on('click', '.btn-offer', async evt => {
    const $btn = $(evt.target).closest('.btn-offer');
    const $tile = $btn.closest('.item-tile, .item-details');
    const amount = $btn.closest('.input-group').find('[name="amount"]').val();
    const { id, type } = $tile.data('item');

    if (!(id > 0 && ['lot', 'listing'].includes(type))) return;

    if (!W.AUTH.authenticated) {
      const result = await $.modal('/login?reason=offer', { id: 'login' });
      if (result !== true) return;
    }

    const result = await $.modal(`/${type}/${id}/offer`, { id: 'offer', size: 'lg', params: { amount } });

    if (result) {
      setTimeout(() => {
        $(`.${type}[data-id="${id}"]`).each((idx, obj) => {
          const $obj = $(obj);
          const item = $obj.data('item');

          item.is_watched = true;
          $obj.addClass('watched');
        });
      }, 150);
    }
  })

  .on('click', '.btn-sounds', evt => {
    let sounds = $.storage.get('sounds') === 'muted' ? 'unmuted' : 'muted';

    $('.btn-sounds .fa')
      .removeClass('fa-volume fa-volume-slash')
      .addClass(`fa-volume${sounds === 'muted' ? '-slash' : ''}`);

    $.storage.set('sounds', sounds);
  })

  .on('click', '.item-watch', async function(evt) {
    const $btn = $(this);
    const $tile = $btn.closest('.item-tile, .item-details');
    const data = $tile.data();
    const action = $tile.hasClass('watched') ? 'remove' : 'add';
    let name;

    evt.stopPropagation();
    evt.preventDefault();

    if (!W.AUTH.authenticated) {
      const result = await $.modal('/login?reason=watch', { id: 'login' });
      if (result !== true) return;
    }

    if ($tile.is('.lot')) name = 'lot_id';
    if ($tile.is('.product')) name = 'product_id';
    if ($tile.is('.listing')) name = 'listing_id';

    const input = Utils.set({ action }, name, data.id);
    const results = await $.GraphQL.runQuery(
      `
      mutation updateWatchList($input: WatchListUpdateInput!) {
        updateWatchList(input: $input) 
      }
    `,
      {
        variables: { input },
        operationName: 'updateWatchList',
      },
    );

    if (results && results.valid) {
      $tile.toggleClass('watched', action === 'add');
      $btn.find('span').text(action === 'add' ? 'Unwatch' : 'Watch');
    }
  })

  .on('click', '.btn-featured', async function() {
    let $btn = $(this);
    let data = $btn.data();
    let id = data.id;

    await $.modal(`/auction/${id}/featured`, { id: 'featured', size: 'lg' });
  })

  .on('click', '.btn-menu-toggle', () => {
    $B.toggleClass('menu');
  })

  .on('click', '.btn-print', () => {
    W.print();
  })

  .on('click', '.btn-share', async evt => {
    const $btn = $(evt.target).closest('.btn-share');
    const $tile = $btn.closest('.item-tile, .item-details');
    const item = $tile.data('item');
    let url, title;

    if (item.type === 'lot') title = `${W.AUTH.website.name} - Lot ${item.item_number}`;

    /* prettier-ignore */
    if ($btn.is('.btn-share-email')) {
      const result = await $.modal(`/lot/${item.id}/share-email`, { id: 'share-email', size: 'lg' });
    }

    else if ($btn.is('.btn-share-twitter')) {
      url = new URL('https://www.twitter.com/intent/post');
      url.searchParams.set('url', location.href);
      if (title) url.searchParams.set('text', title);
    }

    else if ($btn.is('.btn-share-facebook')) {
      url = new URL('https://www.facebook.com/share.php');
      url.searchParams.set('u', location.href);
    }

    if (url) W.open(url, 'share');
  })

  .on('click', '.btn-ask-question', async evt => {
    const $btn = $(evt.target).closest('.btn');
    const $tile = $btn.closest('.item-tile, .item-details');
    const { id } = $tile.data('item');

    const result = await $.modal(`/lot/${id}/ask-question`, { id: 'ask-question', size: 'lg' });
  })

  .on('click', '.item-details .item-image, .item-details .item-media', evt => {
    const $obj = $(evt.target).closest('.item-image, .item-media');
    const $details = $obj.closest('.item-details');
    const item = $details.data('item');
    const idx = parseInt($obj.data('index'));

    if (idx >= 0) $details.gallery(item.media, idx);
  });

$('[name="keyword"]')
  .closest('form')
  .on('form:submit', (evt, vars, data) => {
    const tiles = $('.item-tiles').closest('form').data('item-tiles');
    const { keyword } = data;

    if (tiles) {
      $('[name="keyword"]').val(keyword);
      tiles.applyFilter('keyword', keyword);
    } else location.href = Utils.baseUri('/', { keyword });

    return false;
  });

const setOnboarding = auth => {
  if (!auth.user || !(auth.user.open_invoices || auth.user.open_statements || auth.user.open_title_transfers || auth.user.items_pending_approval)) return;

  $('.badge-onboarding')
    .text(auth.user.open_invoices + auth.user.open_statements + auth.user.open_title_transfers + auth.user.items_pending_approval)
    .removeClass('d-none');

  if (auth.user.open_invoices) $('.badge-invoice-onboarding').text(auth.user.open_invoices).removeClass('d-none');
  if (auth.user.open_statements) $('.badge-statement-onboarding').text(auth.user.open_statements).removeClass('d-none');
  if (auth.user.open_title_transfers) $('.badge-title-transfer-onboarding').text(auth.user.open_title_transfers).removeClass('d-none');
  if (auth.user.items_pending_approval) $('.badge-pending-approval').text(auth.user.items_pending_approval).removeClass('d-none');
};

$.onAuth(auth => {
  const $banners = $('.banner');

  if ($banners.length) {
    if (auth.authenticated) {
      const banners = $.storage.get('banners', []);
      const banners2 = [];

      for (const banner of $banners) {
        const $banner = $(banner);
        const id = $banner.data('id');

        banners2.push(id);
        if (!banners.includes(id)) $banner.removeClass('d-none');
      }

      $.storage.set('banners', Utils.intersection(banners, banners2));
    } else $banners.removeClass('d-none');
  }

  const height = $('.pane-header').outerHeight(true);
  $('.app-sidebar.left').css('max-height', `calc(100vh - ${height}px)`);

  setOnboarding(auth);
});

$D.on('click', '.banner-close', evt => {
  const $banner = $(evt.target).closest('.banner');
  const banners = $.storage.get('banners', []);
  const id = $banner.data('id');

  banners.push(id);
  $.storage.set('banners', banners);
  $banner.addClass('d-none');
});

$(document).on('auth:change', evt => {
  const auth = W.AUTH;
  setOnboarding(auth);
});
